import { useMemo } from 'react';

function useUniquePackages(packageOption) {
  const uniquePackageNames = useMemo(() => {
    if (!packageOption)
      return [
        { key: 'MAGIC_DAILY', name: 'Day' },
        { key: 'MAGIC_WEEKLY', name: 'Week' },
        { key: 'MAGIC_MONTHLY', name: 'Month' },
        { key: 'MAGIC_BUY3', name: 'BUY3' },
        { key: 'MAGIC_BUY5', name: 'BUY5' },
        { key: 'MAGIC_BUY10', name: 'BUY10' },
        { key: 'MAGIC_BUY50', name: 'BUY50' },
      ];

    if (packageOption === 1) {
      // sub package
      return [
        { key: 'MAGIC_DAILY', name: 'Day' },
        { key: 'MAGIC_WEEKLY', name: 'Week' },
        { key: 'MAGIC_MONTHLY', name: 'Month' },
      ];
    }

    if (packageOption === 2) {
      // retail package
      return [
        { key: 'MAGIC_BUY3', name: 'BUY3' },
        { key: 'MAGIC_BUY5', name: 'BUY5' },
        { key: 'MAGIC_BUY10', name: 'BUY10' },
        { key: 'MAGIC_BUY50', name: 'BUY50' },
      ];
    }

    return [
      { key: 'MAGIC_DAILY', name: 'Day' },
      { key: 'MAGIC_WEEKLY', name: 'Week' },
      { key: 'MAGIC_MONTHLY', name: 'Month' },
      { key: 'MAGIC_BUY3', name: 'BUY3' },
      { key: 'MAGIC_BUY5', name: 'BUY5' },
      { key: 'MAGIC_BUY10', name: 'BUY10' },
      { key: 'MAGIC_BUY50', name: 'BUY50' },
    ];
  }, [packageOption]);
  return uniquePackageNames;
}

export default useUniquePackages;
